module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1527-42a6bf39cad60e7bd89d276fccb749c1.png";